import {ResidenceType, StageStatus} from "features/search/filters/enums";
import {SearchResult} from "features/search/types";
import {ResidenceObjectViewModel} from "features/template/viewModels/ResidenceObject";

export const convertToSearchResult = (viewModel:ResidenceObjectViewModel) => {

    return {
        name: viewModel.stageName,
        latitude: viewModel.latitude,
        longitude: viewModel.longitude,
        url: viewModel.stageUrl,
        area: { name: viewModel.areaName },
        areaName: viewModel.areaName,
        county: { name: viewModel.countyName },
        countyName: viewModel.countyName,
        municipality: { name: viewModel.municipalityName },
        municipalityName: viewModel.municipalityName,
        searchImage: viewModel.stageImages[0] ? viewModel.stageImages[0] : null,
        residenceType: viewModel.residenceType as ResidenceType,
        apartmentNumber: "",
        concept: viewModel.concept,
        displayName: "",
        disposalForm: "",
        floor: 0,
        floorPlan: {} as unknown,
        id: "",
        images: viewModel.stageImages,
        inhabitDate: null,
        inhabitDateDetermined: false,
        inhabitDateEnd: new Date(),
        inhabitDateTimeStamp: 0,
        keywords: [],
        maxFloor: 0,
        objectStatus: viewModel.objectStatus,
        outDoorSpaces: [],
        parkingSpaceStatus: viewModel.parkingSpaceStatus,
        possibleRooms: 0,
        price: 0,
        project: "",
        publishedOnSite: [],
        rooms: 0,
        shortDescription: "",
        showing: {} as unknown,
        showings: [],
        siteOrg: "",
        siteId: "",
        stage: "",
        stageName: "",
        stageStatus: viewModel.stageStatus as StageStatus,
        street: "",
        type: "",
        _geo: {
            lat: viewModel.latitude,
            lng: viewModel.longitude,
        }
    } as unknown as SearchResult;
};
